import React from 'react';
import './main.css';
import Catalog from  './Catalog/CatalogSection'


class App extends React.Component {

	render() {
		return(
	  <Catalog title='Login'/>		
		);	
	}
}
export default App;




// WEBPACK FOOTER //
// ./src/components/App.js